module.exports = __webpack_public_path__ + "static/media/progress.0144e3fc.png";